"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VueOOP = exports.Utils = exports.VueOOPOptions = void 0;
const tslib_1 = require("tslib");
const Registry_1 = tslib_1.__importDefault(require("./Registry"));
const Utils = tslib_1.__importStar(require("./utils"));
exports.Utils = Utils;
class VueOOPOptions {
    constructor() {
        this.rest = true;
        this.graphql = false;
        this.schema = null;
        this.schemaUrl = null;
        this.httpEndpoint = null;
        this.wsEndpoint = null;
        this.debug = false;
    }
}
exports.VueOOPOptions = VueOOPOptions;
function VueOOP(Vue, options) {
    const defaultConfig = {
        rest: true,
        graphql: false,
        schema: null,
        schemaUrl: null,
        httpEndpoint: null,
        wsEndpoint: null,
        createProvider: null,
    };
    const config = {
        name: 'default',
        debug: false,
        providers: [],
        ...defaultConfig,
        ...options,
    };
    const registry = Registry_1.default.getInstance();
    registry.set('Config', config);
    Vue.mixin({
        beforeCreate() {
            if (registry.has('Vue'))
                return;
            registry.set('Vue', this.$root);
        },
    });
}
exports.VueOOP = VueOOP;
exports.default = VueOOP;
var Registry_2 = require("./Registry");
Object.defineProperty(exports, "Registry", { enumerable: true, get: function () { return Registry_2.default; } });
var Repository_1 = require("./repositories/Repository");
Object.defineProperty(exports, "Repository", { enumerable: true, get: function () { return Repository_1.default; } });
var Model_1 = require("./models/Model");
Object.defineProperty(exports, "Model", { enumerable: true, get: function () { return Model_1.default; } });
var Collection_1 = require("./models/Collection");
Object.defineProperty(exports, "Collection", { enumerable: true, get: function () { return Collection_1.default; } });
var BaseException_1 = require("./models/Exceptions/BaseException");
Object.defineProperty(exports, "BaseException", { enumerable: true, get: function () { return BaseException_1.default; } });
var InvalidArgumentException_1 = require("./models/Exceptions/InvalidArgumentException");
Object.defineProperty(exports, "InvalidArgumentException", { enumerable: true, get: function () { return InvalidArgumentException_1.default; } });
var UnexpectedException_1 = require("./models/Exceptions/UnexpectedException");
Object.defineProperty(exports, "UnexpectedException", { enumerable: true, get: function () { return UnexpectedException_1.default; } });
var UnauthorizedException_1 = require("./models/Exceptions/UnauthorizedException");
Object.defineProperty(exports, "UnauthorizedException", { enumerable: true, get: function () { return UnauthorizedException_1.default; } });
var ValidationException_1 = require("./models/Exceptions/ValidationException");
Object.defineProperty(exports, "ValidationException", { enumerable: true, get: function () { return ValidationException_1.default; } });
//# sourceMappingURL=index.js.map